import { API_BASE_URL, getAuthHeaders } from './utils';

const handle = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || data.message || 'English reward request failed');
    error.status = response.status;
    error.payload = data;
    throw error;
  }
  return data;
};

export const fetchEnglishRewardEligibility = () =>
  fetch(`${API_BASE_URL}/api/english/specialist-booking/eligibility`, {
    headers: getAuthHeaders(),
  }).then(handle);

export const completeEnglishWeekReview = (journeyWeek) =>
  fetch(`${API_BASE_URL}/api/english/specialist-booking/review`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ journey_week: journeyWeek }),
  }).then(handle);

export const fetchEnglishRewardSlots = (params = {}) => {
  const query = new URLSearchParams();
  if (params.time_from) query.set('time_from', params.time_from);
  if (params.time_to) query.set('time_to', params.time_to);
  if (params.timezone) query.set('timezone', params.timezone);
  const suffix = query.toString() ? `?${query}` : '';
  return fetch(`${API_BASE_URL}/api/english/specialist-booking/slots${suffix}`, {
    headers: getAuthHeaders(),
  }).then(handle);
};

export const bookEnglishRewardSlot = ({ slotStart, teacherUserId, timezone, journeyWeek }) =>
  fetch(`${API_BASE_URL}/api/english/specialist-booking`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({
      slot_start: slotStart,
      teacher_user_id: teacherUserId,
      timezone: timezone || 'UTC',
      journey_week: journeyWeek,
    }),
  }).then(handle);

export const fetchMyEnglishRewardBookings = () =>
  fetch(`${API_BASE_URL}/api/english/specialist-booking/mine`, {
    headers: getAuthHeaders(),
  }).then(handle);

export const cancelEnglishRewardBooking = (bookingId) =>
  fetch(`${API_BASE_URL}/api/english/specialist-booking/${bookingId}/cancel`, {
    method: 'POST',
    headers: getAuthHeaders(),
  }).then(handle);

export const markEnglishRewardJoined = (bookingId) =>
  fetch(`${API_BASE_URL}/api/english/specialist-booking/${bookingId}/join`, {
    method: 'POST',
    headers: getAuthHeaders(),
  }).then(handle);
